// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbRoot":"AdministrationBreadcrumb_breadcrumbRoot__2E0nA","breadcrumbLabel":"AdministrationBreadcrumb_breadcrumbLabel__1HuAe"};